<template>
  <router-link :to='{ name: "ilot", params: { idExploitation : idExploitation, idIlot: ilot.id_ilot }}' class='item-bloc'>
    <header>
      <span>{{ ilot.nom }}</span>
      <button v-can:edit-exploitation class='action-icon delete-btn btn-white' @click.prevent='deleteBloc'/>
    </header>
    <div>
      <div class='subtitle'>Informations générales</div>
      {{ surface }} ha / {{ 'type' | pluralize(nbSols) }} de sol
      <template v-if='materiel'>
        <div class='subtitle'>Matériel</div>
        {{ materiel | pluralize(this.ilot.nombre_materiel) }}
      </template>
      <template v-if='ilot.volume_irrigation'>
        <div class='subtitle'>Irrigation</div>
        {{ ilot.volume_irrigation }} m³
      </template>
    </div>
  </router-link>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BlocIlot',

  props: {
    idExploitation: {
      type: String,
      required: true
    },
    ilot: {
      type: Object,
      required: true
    }
  },

  computed: {
    sols () {
      return this.$store.getters.getSolIlotById(this.ilot.id_ilot)
    },

    nbSols () {
      return this.sols.length
    },

    materiel () {
      if (this.ilot.id_ref_type_materiel) {
        return this.$store.getters['referentiel/getMaterielByIlot'](
          this.ilot.id_ref_type_materiel
        )
      }
      return false
    },
    surface () {
      return this.sols.reduce(
        (total, sol) => total + (parseFloat(sol.surface) || 0),
        0
      )
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),
    deleteBloc () {
      this.confirm({
        title: 'Suppression îlot',
        message: 'Êtes vous-sûr de vouloir supprimer cet îlot ?',
        okText: 'Supprimer'
      }).then(confirmation => {
        if (confirmation) {
          this.$emit('remove', this.ilot)
        }
      })
    }
  }
}
</script>
